
import avatar1 from '../../asset/images/avatar-01.jpg'
import avatar2 from '../../asset/images/avatar-02.jpg'
import avatar3 from '../../asset/images/avatar-03.jpg'

import live1 from '../../asset/images/stream-07.jpg'
import live2 from '../../asset/images/stream-05.jpg'
import live3 from '../../asset/images/stream-06.jpg'
import live4 from '../../asset/images/stream-08.jpg'

import prof1 from '../../asset/images/avatar-01.jpg'
import prof2 from '../../asset/images/avatar-02.jpg'
import prof3 from '../../asset/images/avatar-03.jpg'
import prof4 from '../../asset/images/avatar-04.jpg'

import stream1 from '../../asset/images/featured-01.jpg'
import stream2 from '../../asset/images/featured-02.jpg'
import stream3 from '../../asset/images/featured-03.jpg'


const TopStreamData = [
    { id: 'G1', image: avatar1, name: 'GangTeam' },
    { id: 'G2', image: avatar2, name: 'Omeg' },
    { id: 'G3', image: avatar3, name: 'Kengan' },
    { id: 'G4', image: avatar1, name: 'LahutaM' },
]

const StreamSliderData = [
    { image: stream1, name: 'Gamezer',  rate: '4.8', download: '1.8M' },
    { image: stream2, name: 'Island Rusty',  rate: '4.9', download: '2.5M' },
    { image: stream3, name: 'CS-GO',  rate: '2.6', download: '4.3M' },
    { image: stream2, name: 'Island Rusty',  rate: '4.9', download: '2.5M' },
]

const MostPopularStreamData = [
    { id: 'Mostlive1', image: live1, profile: prof1, caption: 'KenganC', detail: 'Live Streaming Till Morning' },
    { id: 'Mostlive2', image: live2, profile: prof2, caption: 'LunaMa', detail: 'Maybe Nathej Allnight Chillin\'' },
    { id: 'Mostlive3', image: live4, profile: prof3, caption: ' Areluwa', detail: 'CS-GO 36 Hours Live Stream' },
    { id: 'Mostlive4', image: live3, profile: prof4, caption: 'GangTm', detail: 'Just Talking With Fans' },
    { id: 'Mostlive5', image: live2, profile: prof1, caption: 'KenganC', detail: 'Live Streaming Till Morning' },
    { id: 'Mostlive6', image: live4, profile: prof2, caption: 'LunaMa', detail: 'Maybe Nathej Allnight Chillin\'' },
    { id: 'Mostlive7', image: live3, profile: prof3, caption: ' Areluwa', detail: 'CS-GO 36 Hours Live Stream' },
    { id: 'Mostlive8', image: live1, profile: prof4, caption: 'GangTm', detail: 'Just Talking With Fans' },
]

export default TopStreamData
export { MostPopularStreamData, StreamSliderData}

